import { Fragment, useState } from "react";
import Image from "next/image";
import { Props } from "./types";

const ArticleFilter = ({ setSelectedCategory, selectedCategory, categories }: Props) => {
  const [isOpened, setSelectOpened] = useState(false);
  const [categoryName, setCategoryName] = useState("All categories");

  const onClick = () => {
    setSelectOpened(!isOpened);
  };

  return (
    <section>
      <div className="hidden md:flex flex-row justify-around mx-auto max-w-[82.5rem] mb-12 text-landing-orange">
        <div
          className={`pb-2 md:border-b-[1px] md:border-b-ivory md:hover:border-b-landing-orange cursor-pointer ${
            selectedCategory === 0 && "font-bold border-b-landing-orange"
          }`}
          onClick={() => {
            setSelectedCategory(0);
          }}
        >
          All categories
        </div>
        {categories.map(({ id, attributes }, idx) => (
          <div
            className={`pb-2 md:border-b-[1px] md:border-b-ivory md:hover:border-b-landing-orange cursor-pointer ${
              selectedCategory === id && "font-bold border-b-landing-orange"
            }`}
            onClick={() => {
              setSelectedCategory(id);
            }}
            key={idx}
          >
            {attributes?.name}
          </div>
        ))}
      </div>
      <div className="flex md:hidden sticky top-0 z-40 py-5 bg-white">
        <div
          className="text-landing-orange border rounded px-5 py-2 w-full flex justify-between font-bold"
          onClick={onClick}
        >
          {categoryName}
          <Image
            src="/budget-calculator/chevron-orange-bottom.svg"
            width={11}
            height={6}
            alt="down chevron"
            className={`transition-all duration-300 ease-in-out ${
              isOpened === true ? "rotate-180" : "rotate-0"
            }`}
          />
        </div>
        <div
          onClick={onClick}
          className={` ${
            isOpened ? "block" : "hidden"
          } absolute z-50 w-full mt-8 pt-2 bg-white border border-t-0 text-landing-orange`}
        >
          <div
            onClick={() => {
              setSelectedCategory(0);
              setCategoryName("All categories");
            }}
            className={`px-4 py-1 outline-none cursor-pointer focus:bg-grey-50 focus:font-bold hover:bg-grey-50 hover:font-bold ${
              categoryName === "All categories" && "font-bold"
            }`}
          >
            All categories
          </div>
          {categories.map((category, idx) => (
            <Fragment key={idx}>
              <div
                onClick={() => {
                  setSelectedCategory(category.id);
                  setCategoryName(category.attributes.name);
                }}
                className={`px-4 py-1 outline-none cursor-pointer focus:bg-grey-50 focus:font-bold hover:bg-grey-50 hover:font-bold ${
                  category.attributes.name === categoryName && "font-bold"
                }`}
              >
                {category.attributes.name}
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};
export default ArticleFilter;
